import { isEqual } from 'lodash';
import { Contact } from '../../../../providers/api/dtos';

const hasOverwrite = (original: unknown, updated: unknown): boolean => {
  // aggiunta o rimozione → NON overwrite
  if (original == null || updated == null) {
    return false;
  }

  if (typeof original !== 'object' || typeof updated !== 'object') {
    return !isEqual(original, updated);
  }

  return Object.keys({ ...original, ...updated }).some((key) => hasOverwrite(
    (original as Record<string, unknown>)[key],
    (updated as Record<string, unknown>)[key],
  ));
};

export function hasContactOverwrittenData(
  contact: Partial<Contact>,
  overwriteContactValues: Partial<Contact>,
  comparisonKeys?: (keyof Contact)[],
): boolean {
  const keysToCompare = comparisonKeys ?? (Object.keys(contact) as (keyof Contact)[]);

  return keysToCompare.some((key) => hasOverwrite(contact[key], overwriteContactValues[key]));
}
